(() => {
  // src/main-menu.ts
  (() => {
    const timers = /* @__PURE__ */ new WeakMap();
    const openTimers = /* @__PURE__ */ new WeakMap();
    const OPEN_DELAY = 500;
    const drawer = document.getElementById("mobile-nav-drawer");
    const menuOpenBtn = document.querySelector("[data-menu-open]");
    const overlay = document.createElement("div");
    overlay.className = "mobile-nav-drawer__overlay";
    overlay.setAttribute("aria-hidden", "true");
    document.body.appendChild(overlay);
    const openPanel = (item) => {
      const t = timers.get(item);
      if (t) clearTimeout(t);
      timers.delete(item);
      const panel = item.querySelector(".main-menu__mega-panel");
      const trigger = item.querySelector("[data-mega-trigger]");
      if (!panel) return;
      panel.classList.add("is-open");
      trigger == null ? void 0 : trigger.setAttribute("aria-expanded", "true");
      panel.removeAttribute("aria-hidden");
    };
    const cancelOpen = (item) => {
      const t = openTimers.get(item);
      if (t) clearTimeout(t);
      openTimers.delete(item);
    };
    const scheduleOpen = (item) => {
      const panel = item.querySelector(".main-menu__mega-panel");
      if (!panel) return;
      if (panel.classList.contains("is-open")) {
        openPanel(item);
        return;
      }
      if (openTimers.has(item)) return;
      openTimers.set(
        item,
        setTimeout(() => {
          openTimers.delete(item);
          openPanel(item);
        }, OPEN_DELAY)
      );
    };
    const openDrawer = () => {
      if (!drawer) return;
      drawer.classList.add("is-open");
      drawer.setAttribute("aria-hidden", "false");
      overlay.classList.add("is-open");
      menuOpenBtn == null ? void 0 : menuOpenBtn.setAttribute("aria-expanded", "true");
      document.body.style.overflow = "hidden";
    };
    const closeDrawer = () => {
      if (!drawer) return;
      drawer.classList.remove("is-open");
      drawer.setAttribute("aria-hidden", "true");
      overlay.classList.remove("is-open");
      menuOpenBtn == null ? void 0 : menuOpenBtn.setAttribute("aria-expanded", "false");
      document.body.style.overflow = "";
    };
    const scheduleClose = (item) => {
      const t = setTimeout(() => {
        const panel = item.querySelector(".main-menu__mega-panel");
        const trigger = item.querySelector("[data-mega-trigger]");
        if (!panel) return;
        panel.classList.remove("is-open");
        trigger == null ? void 0 : trigger.setAttribute("aria-expanded", "false");
        panel.setAttribute("aria-hidden", "true");
        timers.delete(item);
      }, 200);
      timers.set(item, t);
    };
    const closeAllPanels = () => {
      document.querySelectorAll(".main-menu__nav-item--has-panel").forEach(cancelOpen);
      document.querySelectorAll(".main-menu__mega-panel.is-open").forEach((panel) => {
        var _a, _b;
        panel.classList.remove("is-open");
        panel.setAttribute("aria-hidden", "true");
        (_b = (_a = panel.closest(".main-menu__nav-item--has-panel")) == null ? void 0 : _a.querySelector("[data-mega-trigger]")) == null ? void 0 : _b.setAttribute("aria-expanded", "false");
      });
    };
    const openSubPanel = (panelId) => {
      const main = drawer == null ? void 0 : drawer.querySelector(".mobile-nav-drawer__main");
      const panel = document.getElementById(panelId);
      if (!main || !panel) return;
      main.classList.add("is-hidden");
      panel.classList.add("is-active");
    };
    const closeSubPanels = () => {
      var _a;
      (_a = drawer == null ? void 0 : drawer.querySelector(".mobile-nav-drawer__main")) == null ? void 0 : _a.classList.remove("is-hidden");
      drawer == null ? void 0 : drawer.querySelectorAll(".mobile-nav-drawer__sub-panel.is-active").forEach((p) => p.classList.remove("is-active"));
    };
    document.addEventListener("mouseover", (e) => {
      var _a, _b;
      const item = (_b = (_a = e.target).closest) == null ? void 0 : _b.call(
        _a,
        ".main-menu__nav-item--has-panel"
      );
      if (item) scheduleOpen(item);
    });
    document.addEventListener("mouseout", (e) => {
      var _a, _b;
      const me = e;
      const item = (_b = (_a = me.target).closest) == null ? void 0 : _b.call(
        _a,
        ".main-menu__nav-item--has-panel"
      );
      if (!item) return;
      const related = me.relatedTarget;
      if (related && item.contains(related)) return;
      cancelOpen(item);
      scheduleClose(item);
    });
    document.addEventListener("keydown", (e) => {
      if (e.key !== "Escape") return;
      closeAllPanels();
      closeAccountMenu();
      closeDrawer();
    });
    document.addEventListener("click", (e) => {
      if (!e.target.closest("[data-main-menu]")) {
        closeAllPanels();
        closeAccountMenu();
      }
    });
    const closeAccountMenu = () => {
      document.querySelectorAll("[data-account-trigger]").forEach((trigger) => {
        var _a;
        trigger.setAttribute("aria-expanded", "false");
        const menu = (_a = trigger.closest(".main-menu__account-dropdown")) == null ? void 0 : _a.querySelector(".main-menu__account-menu");
        if (menu) menu.hidden = true;
      });
    };
    document.addEventListener("mouseover", (e) => {
      var _a, _b;
      const dropdown = (_b = (_a = e.target).closest) == null ? void 0 : _b.call(_a, ".main-menu__account-dropdown");
      if (!dropdown) return;
      const trigger = dropdown.querySelector("[data-account-trigger]");
      const menu = dropdown.querySelector(".main-menu__account-menu");
      if (!trigger || !menu) return;
      trigger.setAttribute("aria-expanded", "true");
      menu.hidden = false;
    });
    document.addEventListener("mouseout", (e) => {
      var _a, _b;
      const me = e;
      const dropdown = (_b = (_a = me.target).closest) == null ? void 0 : _b.call(_a, ".main-menu__account-dropdown");
      if (!dropdown) return;
      const related = me.relatedTarget;
      if (related && dropdown.contains(related)) return;
      closeAccountMenu();
    });
    document.addEventListener("click", (e) => {
      const trigger = e.target.closest("[data-account-trigger]");
      if (!trigger) return;
      const dropdown = trigger.closest(".main-menu__account-dropdown");
      const menu = dropdown == null ? void 0 : dropdown.querySelector(".main-menu__account-menu");
      if (!menu) return;
      const isOpen = menu.hidden === false;
      closeAccountMenu();
      if (!isOpen) {
        menu.hidden = false;
        trigger.setAttribute("aria-expanded", "true");
      }
      e.stopPropagation();
    });
    document.addEventListener("click", (e) => {
      const target = e.target;
      if (target.closest("[data-menu-open]")) {
        openDrawer();
        return;
      }
      if (target.closest("[data-menu-close]") || target === overlay) {
        closeSubPanels();
        closeDrawer();
        return;
      }
      const subPanelLink = target.closest("[data-mobile-sub-panel]");
      if (subPanelLink) {
        e.preventDefault();
        openSubPanel(subPanelLink.dataset.mobileSubPanel);
        return;
      }
      if (target.closest("[data-sub-panel-back]")) {
        closeSubPanels();
      }
    });
  })();
})();
